export default __webpack_public_path__ + "static/media/ScienceChannel.f9c41e1a.svg";